import { Outlet, NavLink } from 'react-router-dom';
import { Home, Calendar, Upload, DollarSign, User } from 'lucide-react';
import { T, F } from '@/lib/dispatchApi';

const tabs = [
  { path: '/dispatch/today',    label: 'Today',    Icon: Home },
  { path: '/dispatch/schedule', label: 'Schedule', Icon: Calendar },
  { path: '/dispatch/upload',   label: 'Upload',   Icon: Upload },
  { path: '/dispatch/payouts',  label: 'Pay',      Icon: DollarSign },
  { path: '/dispatch/account',  label: 'Me',       Icon: User },
];

export default function DispatchLayout() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      height: '100dvh', backgroundColor: T.night, color: T.moon,
      fontFamily: F.heading,
    }}>
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </div>

      <nav style={{
        display: 'flex', flexDirection: 'row',
        borderTop: `1px solid ${T.nightHair}`,
        backgroundColor: T.night,
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        flexShrink: 0,
      }}>
        {tabs.map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            style={({ isActive }) => ({
              flex: 1,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
              padding: '10px 0 8px',
              color: isActive ? T.attnText : T.moonFaint,
              textDecoration: 'none',
              fontSize: 11, letterSpacing: 0, gap: 4, minHeight: 56,
              fontFamily: F.heading,
            })}
          >
            {({ isActive }) => (
              <>
                <Icon size={20} color={isActive ? T.attnText : T.moonFaint} strokeWidth={isActive ? 2 : 1.5} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
